export default {
  state: {
    ftaToken: ''
  },
  mutations: {
    ftaToken (state, value) {
      state.ftaToken = value
    }
  }
}
